import { render, staticRenderFns } from "./NavigationOverlay.vue?vue&type=template&id=10ac4c62&scoped=true"
import script from "./NavigationOverlay.vue?vue&type=script&lang=js"
export * from "./NavigationOverlay.vue?vue&type=script&lang=js"
import style0 from "./NavigationOverlay.vue?vue&type=style&index=0&id=10ac4c62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ac4c62",
  null
  
)

export default component.exports